import { dictionary } from '../../../../dictionary';
import { FormFieldDescriptor } from '../../../../Shared/fields/formTypes';
import { createDescriptor } from '../../../../Utils/formik.utils';

export const createPatientFieldDescriptors: Record<string, FormFieldDescriptor> = {
  firstName: createDescriptor({ name: 'firstName', label: dictionary.FORM_CONTROL_LABEL_FIRST_NAME, required: true }),
  lastName: createDescriptor({ name: 'lastName', label: dictionary.FORM_CONTROL_LABEL_LAST_NAME, required: true }),
};
